export default "__VITE_ASSET__DhMAolzi__"